export default __webpack_public_path__ + "static/media/ORANGE_118_712.7a3f41ec.png";